import { useQuery } from '@tanstack/react-query';
import { teacherImageList } from '../../../constants/teacherImages';

const TeacherSection = ({ id }) => {
  const API_URL = import.meta.env.VITE_API_URL;

  const { data, isLoading } = useQuery({
    queryKey: ['teacher', id],
    queryFn: async () => {
      const response = await fetch(`${API_URL}/bbs/ajax.get_teacher.php?te_id=${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error("네트워크 오류");
      }

      return response.json();
    },
    enabled: !!id,
  });
  const item = data?.item
    ? { ...data.item, file: teacherImageList[data.item.name?.trim()] || null }
    : null;


  	return (
	    <div className="space-y-12">
	        {item && (
	        	<div key={item.id} className="space-y-8 border-b border-gray-200 pb-10 last:border-none">
                    <div className="flex items-start space-x-6">
                        {item.file ? (
                            <img src={item.file} alt={item.name} className="w-32 h-32 rounded-full object-cover"/>                        
                        ) : (
                            <div className="w-32 h-32 rounded-full bg-gray-200 flex items-center justify-center mb-4 border-4 border-gray-100"><i className="ri-user-line text-4xl text-gray-400"></i></div>
                        )}
                        <div className="flex-1">
                            <h3 className="text-2xl font-bold text-gray-900 mb-2">
                                {item.name} 선생님
                            </h3>
                            <p className="text-purple-600 font-medium mb-4">
                                {item.specialties.join(', ')}
                            </p>
                        </div>
                    </div>
                    {item.badge && (
                        <div>
                            <h4 className="text-xl font-bold text-gray-900 mb-3">수료배지</h4>
                            <img src={item.badge} alt={item.badge} className="max-w-[250px] rounded-xl"/>
                        </div>
                    )}
                    <div>
                        <h4 className="text-xl font-bold text-gray-900 mb-3">학력</h4>
                        <ul className="space-y-2">
                            {item.educations?.map((education, index) => (
                                <li key={index} className="flex items-center space-x-3">
                                    <i className="ri-graduation-cap-fill text-purple-600 text-xl mt-1"></i>
                                    <span className="text-gray-700">{education}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-xl font-bold text-gray-900 mb-3">경력</h4>
                        <ul className="space-y-2">
                            {item.careers?.map((career, index) => (
                                <li key={index} className="flex items-center space-x-3">
                                    <i className="ri-briefcase-fill text-purple-600 text-xl mt-1"></i>
                                    <span className="text-gray-700">{career}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
	        )}
	    </div>
    );
};

export default TeacherSection;
